// extracted by mini-css-extract-plugin
export default {"wrap":"SelectCustomStyle_wrap__fOjXm","wrapBody":"SelectCustomStyle_wrapBody__J1d3L","wrapBodyActive":"SelectCustomStyle_wrapBodyActive__pkpIS"};